import fetch from 'auth/FetchInterceptor'

// Mounted at /crm/positions; backend translates between the frontend's `title`
// (free-text) and the existing Position dictionary FK on `CrmDealRole`.
const PositionService = {
  getAll: (params = null) =>
    fetch({ url: '/crm/positions', method: 'get', params }),
  get: (id) => fetch({ url: `/crm/positions/${id}`, method: 'get' }),
  create: (data) => fetch({ url: '/crm/positions', method: 'post', data }),
  update: (id, data) =>
    fetch({ url: `/crm/positions/${id}`, method: 'patch', data }),
  remove: (id) => fetch({ url: `/crm/positions/${id}`, method: 'delete' }),
  move: (id, payload = {}) =>
    fetch({ url: `/crm/positions/${id}/move`, method: 'post', data: payload }),
}

export default PositionService
